import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-[16px] lg:text-md leading-tight font-bold" }
const _hoisted_2 = { class: "flex items-center gap-3 lg:gap-5 text-base-200 text-xs lg:text-base" }
const _hoisted_3 = { class: "overflow-hidden" }
const _hoisted_4 = { class: "p-4 md:p-5" }
const _hoisted_5 = { class: "mb-5 text-center" }
const _hoisted_6 = { class: "mb-1 text-md font-bold leading-tight" }
const _hoisted_7 = { class: "text-base-200" }
const _hoisted_8 = { class: "max-w-[300px] mx-auto mt-5 text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-lg leading-lg font-bold" }

import { computed, inject, ref } from 'vue';
import { AppConfigType, ScheduleType } from '~src/admin/types';
import BaseSchedule from './BaseSchedule.vue';
import Button from '../base/Button.vue';
import IconArrowDown from '../icons/IconArrowDown.vue';
import IconTrash from '../icons/IconTrash.vue';
import Popup from '../layout/Popup.vue';
import IconWarning from '../icons/IconWarning.vue';
import Axios from '~src/shared/axios';
import { useNotificationStore } from '~src/admin/stores/useNotificationStore';
import { useGettext } from 'vue3-gettext';
import { useSchedulesStore } from '~src/admin/stores/useSchedulesStore';
import { useTokensStore } from '~src/admin/stores/useTokensStore';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleAccordion',
  props: {
    schedule: {}
  },
  setup(__props: any) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Show notification
const { addNotification } = useNotificationStore();

// Get schedule actions
const { editSchedule, removeSchedule } = useSchedulesStore();

// Get schedule actions
const { updateTokens } = useTokensStore();

// Props


// Current schedule
const currentSchedule = ref<ScheduleType>(__props.schedule);

// Get limit reached
const { isTokenLimitReached } = useTokensStore();

// Popup control
const deletePopup = ref<InstanceType<typeof Popup>>();

// Loading for delete end edit
const requestLoading = ref(false);

// Control accordion
const accordionActive = ref(false);

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

// Account expired
const isAccountExpired = inject<boolean>('isAccountExpired');

// Remove schedule
const scheduleAction = async (action: 'EDIT' | 'DELETE') => {
    // Setup messages
    let successMsg = $gettext('Succesfully removed schedule');
    let errorMsg = $gettext('There was an error with deleting schedule!');

    if (action === 'EDIT') {
        successMsg = $gettext('Succesfully edited schedule');
        errorMsg = $gettext('There was an error while editing schedule!');
    }

    try {
        // Set loading
        requestLoading.value = true;

        // Get the schedule ID
        const scheduleID = __props.schedule.id;

        // Set url and body
        let bodyBoostsite = {
            schedule_id: scheduleID,
            action: 'delete',
        };

        if (action === 'EDIT') {
            bodyBoostsite['schedule'] = currentSchedule.value;
            bodyBoostsite['action'] = 'edit';
        }

        // Change the schedule in Boostsite API
        const responseBoostsite = await Axios.post(`${config.rest.endpoints.boostsite}/schedules`, bodyBoostsite);

        // Check if the response is successful
        if (responseBoostsite.status !== 200 || !responseBoostsite.data.success) {
            throw new Error(`REST API error: ${responseBoostsite.status} - ${responseBoostsite.statusText}`);
        }

		// Update schedules in store
		if (action === 'DELETE') {
			// Remove schedule from store
			removeSchedule(scheduleID);
		} else if (action === 'EDIT') {
			// Update schedule in store
			editSchedule(currentSchedule.value);
		}

        // Show notificaiton
        addNotification({
            message: `${successMsg} ${currentSchedule.value.topic}!`,
            type: 'success',
        });

		// Refresh the tokens
		updateTokens();
    } catch (error) {
        console.error('Error during API call:', error);

        // Show error
        addNotification({
            message: errorMsg,
            type: 'danger',
        });
    } finally {
        // Set loading
        requestLoading.value = false;

        // Close popup
        deletePopup.value.closePopup();
    }
};

// Calculate article usage
const usedArticles = computed(() => {
    // Sum existing articles and the potential new ones
    let currentSum = 0;

    if (currentSchedule.value.advSchedule) {
        // Advanced schedule
        currentSum = Object.values(currentSchedule.value.advSchedule).reduce((sum, arr) => sum + arr.length, 0);
    } else if (!currentSchedule.value.advSchedule) {
        // Basic schedule
        currentSum = currentSchedule.value.days.length;
    }

    return currentSum;
});

// Store inital used articles
const initialUsedArticles = usedArticles.value;

// If the limit is reached can only save the articles that have less planned than previosly
const tokenLimitReached = computed(() => {
	if (isTokenLimitReached.value) {
		return usedArticles.value > initialUsedArticles;
	}
	return false;
});

// 'Article' correct form
const articleWord = computed(() => {
    return currentSchedule.value.days.length === 1 ? $gettext('article') : $gettext('articles');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'border border-neutral-500 bg-white rounded-lg transition-colors',
            !accordionActive.value && 'hover:border-primary-500',
			requestLoading.value && 'pointer-events-none',
        ])
  }, [
    _createElementVNode("div", {
      class: "p-4 md:p-5 flex justify-between items-center gap-2.5 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (accordionActive.value = !accordionActive.value))
    }, [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(currentSchedule.value.topic), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(usedArticles.value) + " " + _toDisplayString(articleWord.value) + " " + _toDisplayString(_unref($gettext)('weekly')), 1),
        _createVNode(IconArrowDown, {
          class: _normalizeClass(['text-base-500 transition-transform', accordionActive.value && 'rotate-180'])
        }, null, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['grid grid-rows-[0fr] transition-all duration-500', accordionActive.value && 'grid-rows-[1fr]'])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref($gettext)('When articles should be published?')), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref($gettext)(
                                    'We will generate and publish articles on your behalf on a given days and time.'
                                )), 1)
          ]),
          _createVNode(BaseSchedule, {
            schedule: currentSchedule.value,
            "is-preview": true,
            onUpdateSchedule: _cache[1] || (_cache[1] = (newSchedule) => currentSchedule.value = newSchedule)
          }, null, 8, ["schedule"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              class: "mb-4 w-full",
              text: _unref($gettext)('Save changes'),
              size: "large",
              disabled: _unref(isAccountFree) || tokenLimitReached.value || _unref(isAccountExpired),
              loading: requestLoading.value,
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (scheduleAction('EDIT')), ["prevent"]))
            }, null, 8, ["text", "disabled", "loading"]),
            _createVNode(Button, {
              text: _unref($gettext)('Delete schedule'),
              type: "danger",
              "icon-position": 'left',
              "has-background": false,
              disabled: _unref(isAccountFree) || _unref(isAccountExpired),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ((_unref(isAccountFree) || _unref(isAccountExpired)) ? null : deletePopup.value.openPopup()), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(IconTrash)
              ]),
              _: 1
            }, 8, ["text", "disabled"])
          ])
        ])
      ])
    ], 2),
    _createVNode(Popup, {
      ref_key: "deletePopup",
      ref: deletePopup,
      "cancel-button-text": _unref($gettext)('Cancel'),
      "confirm-button-text": _unref($gettext)('Delete'),
      "confirm-button-type": "danger",
      size: "small",
      onPopupConfirm: _cache[4] || (_cache[4] = ($event: any) => (scheduleAction('DELETE'))),
      loading: requestLoading.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(IconWarning, { class: "mb-4 mx-auto" }),
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref($gettext)('Are you sure?')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref($gettext)("Deleted schedule can't be restored.")), 1)
        ])
      ]),
      _: 1
    }, 8, ["cancel-button-text", "confirm-button-text", "loading"])
  ], 2))
}
}

})